import React, { ChangeEvent } from 'react';
import { Col, Form, FormControl, FormGroup, Row } from 'react-bootstrap';
import HelpButton from '../../../Form/HelpButton';
import IFormStep from '../../../../interfaces/IFormStep';
import { IAppMultipleChoiceRequirement } from '../../../../interfaces/IApplicationRequirements';

const ActivityDetails: React.FC<IFormStep> = ({
    formData,
    requirements,
    handleInputChange,
    models,
}) => {
    const help = requirements.config?.help && requirements.config?.help['activityDetails'];
    const activityDetails = formData.activityDetails ?? '';
    const { minLength, maxLength, required, subtitle } = requirements!.activityDetails!;

    const activityExperiences = requirements.experience.find(
        (exp) => exp.name === 'activities'
    ) as IAppMultipleChoiceRequirement;
    const activityExp: string[] = formData.experiences.find(
        (exp) => exp.name === 'activities'
    )!.value;

    const handleOnChange = (e: ChangeEvent<HTMLInputElement>) =>
        handleInputChange('activityDetails', e.target.value);

    return (
        <Row>
            <h2>
                Activity Details
                {help && <HelpButton title={'Activity Details'} content={help} />}
            </h2>
            <p className={'text-black'}>
                You should be able to evidence engagement in the following from at least 3 of your
                activities:
            </p>
            <Row>
                <Col>
                    <ul className={'text-black'}>
                        {activityExperiences.choices
                            .filter((choice) => activityExp.includes(choice.name))
                            .map((choice) => (
                                <li key={choice.name}>{choice.label}</li>
                            ))}
                    </ul>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Form.Label className={'text-black w-100 h-100'}>
                            {subtitle}
                            <FormControl
                                as={'textarea'}
                                rows={10}
                                name={'value'}
                                value={activityDetails}
                                onChange={handleOnChange}
                                minLength={minLength}
                                maxLength={maxLength}
                                required={required}
                            />
                        </Form.Label>
                        <div>
                            {(minLength || 0) > 0 && activityDetails.length < (minLength || 0) && (
                                <Form.Text className={'flex-grow-0'}>
                                    Enter at least {minLength} characters
                                </Form.Text>
                            )}
                            {maxLength && activityDetails.length > maxLength && (
                                <Form.Text className={'flex-grow-0 text-danger'}>
                                    Too many characters
                                </Form.Text>
                            )}
                            {maxLength && (
                                <Form.Text
                                    className={`flex-grow-0 float-end text-end ${(activityDetails.length || 0) > maxLength && 'text-danger'}`}
                                >
                                    {activityDetails.length || 0}/{maxLength}
                                </Form.Text>
                            )}
                        </div>
                    </FormGroup>
                </Col>
            </Row>
        </Row>
    );
};

export default ActivityDetails;
